"use strict";

import round from "./../utils/round";
import convertUnit from "./convertUnit";

export default function createWellQuantity(unitAssignment, application, value, originalUnit, representationType) {
	
	representationType = representationType || 'float';
	var prec = representationType.toLowerCase() === 'integer' ? 0 : 1;
	
	if (!application) {
		return {
			value: round(value, prec)
		};
	}
	
	var displayUnit = unitAssignment[application];
	
	return {
		value: round(convertUnit(originalUnit, displayUnit, value), prec),
		unit: displayUnit
	};
}


// WEBPACK FOOTER //
// ./~/vwa/quantity/createWellQuantity.js